import React from "react";

const loader = () => {
  return (
    <div className="spinner-border w-80" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
};

export default loader;
